<style scoped>

.settings-parameter-container .groupForm_type {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 50px;
}

.settings-parameter-container .groupForm_type .groupForm_type_single {
  padding: 5px 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-right: 0.9375rem;
  width: 13.75rem;
  cursor: pointer;
  position: relative;
  height: 6rem;
  border-radius: 0.375rem 0.375rem 0.375rem 0.375rem;
  border: 0.0625rem solid #d0d0d0;
}

.settings-parameter-container .groupForm_type .groupForm_type_single .groupForm_type_single_title {
  font-size: 1rem;
  font-weight: bold;
  color: #1a1a1a;
  margin-bottom: 0.5rem;
}

.settings-parameter-container .groupForm_type .groupForm_type_single .groupForm_type_single_tips {
  font-size: 0.75rem;
  color: #9196b1;
}


.settings-parameter-container .groupForm_type .groupForm_type_single_select {
  background: #e8f4ff;
  border-color: #0058ff;
}

.settings-parameter-container .groupForm_type .groupForm_type_single_select .groupForm_type_icon {
  position: absolute;
  top: 0;
  right: 0;
  width: 2.0625rem;
  height: 2.0625rem;
}

.standard-edition-notice{
  color: #E6A23C!important;
}
</style>

<template>
  <div class="settings-parameter-container">
    <div data-v-344cbe9a="" class="groupForm_type">
      <div @click="handleUpdateSystemVersionType(1)"
           :class="systemVersionType == 1?'groupForm_type_single groupForm_type_single_select':'groupForm_type_single'">
        <img v-if="systemVersionType == 1" data-v-344cbe9a="" class="groupForm_type_icon"
             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAYAAADjVADoAAAAAXNSR0IArs4c6QAAA0hJREFUeF7t10tIFVEYwPH/FAZiCaZCRElBroxIIrCQilwIRUSLyAgk2lWLiKDQyleQ4CYKTFoUFRiKPTEIyUf0AAuCErOFYSUEIRkolZDoxGkC71zn3pm5d96ns7tw7pnz/eb7zndGoUKtA2qJ/phEZQiFIeAhbcq92JCVvz8qVAEhQOQZKo+YZT8dyoQIWoOQFQMG+MkmOpVfcxAahixlEpv5N2hTDuohZM2MGTbPh5AxM1SuGEPIlhkqg4khZMoMlYnkEBJhmENIgmENQgIM6xAhxchdDOM/zC/M9iBChCECaz4EO4phaz18/pYcwz5ECDAWKHDzCBwo1YL/8h221MPIWGKM1CACjJGxENqPwZ6N+qDffILiKjcgAoiRmQGdJ6FsrT7gj2OwrQFGx92CCBBGdiZ0VUFJoT7Y4a9QWgtjk26cEfFr+vzVKjpD71lYV6Df2MAobD/nVtdIBOsTxvIceFIDhcv0G+sfhvJGmJwyb51iRuqHpdH6HmOsztcQCvL0m+kZhF1NMDVtDcF5CAfODFHrJ3ZCwx2YURMHIsqg+zTkZ+vn3H0FFZdgesY6gjsQaWDkZEHvGVi/Cm6/hH0XYdYAo2QNdFWDQIsdrc+h8rLxf8xYnC2N2KfZLJO8JVqaF62YW8QosLIirUVmLtKH1vIYjl6DJEmU1MI9CJuZYQQhlojF2L0BOo6DuDTFjsb7UN1u9s69aJ/JnmEjM5ZmQV/N/DZ4tQ+evofrh0GJe3WnbkFTZ3oI7p0R8fuygSHOiWd1+hIxClNVtVJo6U4fwTsIm2VihiEO0MpmaH3hDIK3EA5hiLa49wI8eO0cgvcQaWJM/dYuSj3vnEXwByJFjJW5UH4e+j84j+AfhE0M0U0ExNtRdxD8hbCJ4R6BtrK7Fyoru7fRWq0sl+oc/yECkhnBgAgARnAgfMYIFoSPGMGD8AkjmBA+YAQXwmOMYEN4iBF8CI8wwgHhAUZ4IFzGCBeEixjhg3AJI5wQLmCEF8JhjHBDOIgRfgiHMKIB4QBGdCDSxIgWRBoY0YNIESOaEClgRBfCJka0IWxgRB/CIoYcEBYw5IEwwZALIgmGfBAJMOSEMMCQFyIOQ26IGIz/EP8w/gDUgS85M3pMxgAAAABJRU5ErkJggg==">
        <div data-v-344cbe9a="" class="groupForm_type_single_title">标准版</div>
        <div data-v-344cbe9a="" class="groupForm_type_single_tips"> 标准版仅支持设备门禁规则</div>
        <div data-v-344cbe9a="" class="groupForm_type_single_tips standard-edition-notice"> 注：专业版切换标准版需手动删除用户门禁规则，节假日规则</div>
      </div>
      <div @click="handleUpdateSystemVersionType(2)"
           :class="systemVersionType == 2?'groupForm_type_single groupForm_type_single_select':'groupForm_type_single'">
        <!---->
        <img v-if="systemVersionType == 2" data-v-344cbe9a="" class="groupForm_type_icon"
             src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAYAAADjVADoAAAAAXNSR0IArs4c6QAAA0hJREFUeF7t10tIFVEYwPH/FAZiCaZCRElBroxIIrCQilwIRUSLyAgk2lWLiKDQyleQ4CYKTFoUFRiKPTEIyUf0AAuCErOFYSUEIRkolZDoxGkC71zn3pm5d96ns7tw7pnz/eb7zndGoUKtA2qJ/phEZQiFIeAhbcq92JCVvz8qVAEhQOQZKo+YZT8dyoQIWoOQFQMG+MkmOpVfcxAahixlEpv5N2hTDuohZM2MGTbPh5AxM1SuGEPIlhkqg4khZMoMlYnkEBJhmENIgmENQgIM6xAhxchdDOM/zC/M9iBChCECaz4EO4phaz18/pYcwz5ECDAWKHDzCBwo1YL/8h221MPIWGKM1CACjJGxENqPwZ6N+qDffILiKjcgAoiRmQGdJ6FsrT7gj2OwrQFGx92CCBBGdiZ0VUFJoT7Y4a9QWgtjk26cEfFr+vzVKjpD71lYV6Df2MAobD/nVtdIBOsTxvIceFIDhcv0G+sfhvJGmJwyb51iRuqHpdH6HmOsztcQCvL0m+kZhF1NMDVtDcF5CAfODFHrJ3ZCwx2YURMHIsqg+zTkZ+vn3H0FFZdgesY6gjsQaWDkZEHvGVi/Cm6/hH0XYdYAo2QNdFWDQIsdrc+h8rLxf8xYnC2N2KfZLJO8JVqaF62YW8QosLIirUVmLtKH1vIYjl6DJEmU1MI9CJuZYQQhlojF2L0BOo6DuDTFjsb7UN1u9s69aJ/JnmEjM5ZmQV/N/DZ4tQ+evofrh0GJe3WnbkFTZ3oI7p0R8fuygSHOiWd1+hIxClNVtVJo6U4fwTsIm2VihiEO0MpmaH3hDIK3EA5hiLa49wI8eO0cgvcQaWJM/dYuSj3vnEXwByJFjJW5UH4e+j84j+AfhE0M0U0ExNtRdxD8hbCJ4R6BtrK7Fyoru7fRWq0sl+oc/yECkhnBgAgARnAgfMYIFoSPGMGD8AkjmBA+YAQXwmOMYEN4iBF8CI8wwgHhAUZ4IFzGCBeEixjhg3AJI5wQLmCEF8JhjHBDOIgRfgiHMKIB4QBGdCDSxIgWRBoY0YNIESOaEClgRBfCJka0IWxgRB/CIoYcEBYw5IEwwZALIgmGfBAJMOSEMMCQFyIOQ26IGIz/EP8w/gDUgS85M3pMxgAAAABJRU5ErkJggg==">
        <div data-v-344cbe9a="" class="groupForm_type_single_title">专业版</div>
        <div data-v-344cbe9a="" class="groupForm_type_single_tips"> 专业版支持用户门禁规则，节假日规则</div>
      </div>
    </div>
<!--    <div class="groupForm_type">
      <div style="display: flex;justify-content: start;align-items: center;color:#409EFF">
        <el-tooltip class="item" effect="dark" content="请联系管理员开通访客短信通知" placement="top">
          <i class="el-icon-info" style="font-size: 18px;margin-right: 10px;cursor: pointer;"></i>
        </el-tooltip>是否启用访客短信通知：
      </div>
      <el-tag effect="plain" size="small" v-if="enabledSms">是</el-tag>
      <el-tag effect="plain" size="small" v-else>否</el-tag>
    </div>
    <div class="groupForm_type">
      <el-checkbox v-model="enabledFace" size="medium" border @change="handleEnabledFace">是否启用访客人脸识别</el-checkbox>
    </div>-->
  </div>

</template>


<script>
import {CompanyApi} from "@/api/server/company";

export default {
  components: {},
  data() {
    return {
      systemVersionType: 1 ,//1-标准版 2-专业版
      enabledSms: false,  //是否启用短信
      enabledFace: false, //是否启用人脸识别
    };
  },
  created() {
    this.init();
  },
  mounted() {

  },
  methods: {
    async init() {
      CompanyApi.queryCurrentCompany().then(response => {
        let {code, data} = response;
        if (code == 200) {
          this.systemVersionType = data?.systemVersionType || 1;
          this.enabledSms = data?.enabledSms || false;
          this.enabledFace = data?.enabledFace || false;
        }
      })
    },
    async handleUpdateSystemVersionType(type) {
      if(1 == type){
        await this.$confirm('专业版切换标准版需手动删除用户门禁规则，节假日规则');
      }
      this.systemVersionType = type;
      CompanyApi.updateSystemVersionType(type).then(response => {
        let {code, message} = response;
        if (code == 200) {
          this.$message.success('修改成功');
          setTimeout(() => {
            location.reload();
          }, 200)
        } else {
          this.$message.error(message);
        }
      });
    },
    async handleEnabledFace(){
      CompanyApi.updateEnabledFace(this.enabledFace).then(response => {
        let {code, message} = response;
        if (code == 200) {
          this.$message.success('修改成功');
        } else {
          this.$message.error(message);
        }
      });
    }
  }
};
</script>